<template>
  <div class="text-xs-center">
    <b-pagination-nav
      :value="current"
      :number-of-pages="pages"
      :use-router="true"
      :link-gen="linkGen"
      :page-gen="pageGen"
      :align="align"
    />
  </div>
</template>

<script>
import { BPaginationNav } from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/pagination-nav.scss';
import { getSearchLinksQuery } from 'utils/SearchFilterHelper';
/**
 * TODO
 * set smooth scroll to first and next buttons
 */
export default {
  name: 'PaginationNav',
  components: { BPaginationNav },
  props: {
    pages: {
      type: Number,
      default: 1,
    },
    current: {
      type: [Number, String],
      default: null,
    },
    perPage: {
      type: Number,
      default: 1,
    },
    target: {
      type: Object,
      default: () => ({
        hash: '#searchResult',
        behavior: 'smooth',
        name: 'Search',
      }),
    },
    align: {
      type: String,
      default: 'left',
    },
  },
  mounted() {
    // console.log('pagnav');
  },
  methods: {
    // Returning a router-link `to` object with query parameters
    linkGen(pageNum) {
      const linkGen = {
        path: this.$router.currentRoute.path,
        // name: this.target.route,
        query: { ...getSearchLinksQuery(this.$store, this.$route), page: pageNum },
        hash: this.target.hash,
      };
      // EDVUE-3105, remove page=1 from all paginations
      if (pageNum === 1) {
        delete linkGen.query.page;
      }
      return linkGen;
    },
    pageGen(pageNum) {
      return pageNum;
    },
  },
};
</script>

<style lang="scss" src="@/scss/components/search/PaginationNav.scss" scoped clientextend></style>
